import * as React from 'react';
import * as styles from './styles.css';
import { ITextListCell } from '../../../../../../types/newbuildingsCompare';
import { Body1, Label } from '@cian/ui-kit';
import clsx from 'clsx';

export interface ITextListCellProps {
  cell: ITextListCell;
  isInfrastructureBlock: boolean;
  hasCountText: boolean;
}

export const TextListCell = ({ cell, isInfrastructureBlock, hasCountText }: ITextListCellProps): React.JSX.Element => {
  if (!cell.data?.items?.length) {
    return (
      <div className={clsx(styles['container'], hasCountText && styles['container-with-count'])}>
        <Body1 color="text-primary-disabled">{cell.state.text ?? ''}</Body1>
      </div>
    );
  }

  return (
    <div
      className={clsx(
        isInfrastructureBlock && styles['container-infrastructure'],
        styles['container'],
        hasCountText && styles['container-with-count'],
      )}
    >
      {cell.data.items.map((item, index) => (
        <Body1 key={index}>{item}</Body1>
      ))}
      {cell.data.countText && (
        <Label background="accent-ghost-secondary" className={styles['count-label']} color="accent-ghost-primary">
          {cell.data.countText}
        </Label>
      )}
    </div>
  );
};
